import React, { useContext, useState } from "react";
import { StatusContext } from "../../contexts/Status.context";
import ReactPlayer from "react-player";
import CommonBtn from "../../components/buttons/commonBtn";
import { apiService } from "../../services/api.service";
import { shuffleArray, makeProblems, shuffleNumArray } from "../../utils";
import { toast } from "react-toastify";
import LoadingScreen from "../../components/UI/LoadingScreen";
import useTranslation from "../../hooks/useTranslation";
import FinishSectionFree from "./FinishSectionFree";
import MechanicsFree from "./MechanicsFree";

const FreeTest = () => {
  const [isTestStart, setIsTestStart] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { setProblems, setMetvProblems, setModule, problemNumber } =
    useContext(StatusContext);
  const { t } = useTranslation();

  const handleProblems = async () => {
    setIsLoading(true);
    let folderName = "publictest/";
    try {
      const res = await apiService.getVideosFromAWS(folderName);
      const { data } = res;
      setModule(folderName.replace("/", ""));
      const array = shuffleArray(
        data
          .slice(1, data.length)
          .filter((item: string) => item.indexOf("-s.mp4") == -1)
      ).slice(0, 10);
      setMetvProblems(makeProblems(array));
      setProblems(shuffleNumArray(10));
      setIsTestStart(true);
    } catch (error) {
      toast.error("Failed to get problems.");
    }
    setIsLoading(false);
  };

  const handleNext = () => {
    handleProblems();
  };

  return (
    <div>
      {isTestStart ? (
        problemNumber > 10 ? (
          <FinishSectionFree />
        ) : (
          <MechanicsFree />
        )
      ) : (
        <div className="block lg:w-[80%] xl:w-[60%] lg:mx-auto">
          <div className="lg:w-[100%]">
            <div className="relative pt-[56.25%]">
              <div className="absolute top-0 right-0 left-0 bottom-0 flex items-center">
                <ReactPlayer
                  url={"https://youtu.be/TsAp9aqwxTA"}
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
            <div className="text-center mt-8">
              <CommonBtn status={0} onClick={handleNext}>
                {t("Next")}
              </CommonBtn>
            </div>
          </div>
          {isLoading && <LoadingScreen />}
        </div>
      )}
    </div>
  );
};

export default FreeTest;
